export const environment = {
  production: false,
  name: 'dev',
  BASE_PATH: 'https://dev.api.syneco.net/green-x-energy-hub',
  AUTH: {
    OIDC_ISSUER: 'https://sso.dev.hosting.syneco.net/auth/realms/Syneco-Portal',
    REQUIRE_HTTPS: true
  },
  SKIP_CAPTCHA: false,
  JIRA: {
    BASE_URL: 'https://syneco-sandbox-963.atlassian.net'
  }
};
